<h6 mat-dialog-title class="heading text-primary">Table Columns</h6>
<div mat-dialog-content>
  <div class="row m-0 p-0">
    <div class="col-12 py-2">
      <div class="example-list" cdkDropList (cdkDropListDropped)="onDrag($event)">
        @for (item of columnMasterList; track item; let i = $index) {
          <div class="example-box" cdkDrag>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <mat-checkbox class="ms-2" [(ngModel)]="item.IsSelected"></mat-checkbox>
                <span class="ms-2 mt-1 {{ item.ColumnBackground }} {{ item.ColumnColor }}">{{ item.ColumnName }}</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button class="btn-md-outlined-error" tabindex="-1" matRipple [mat-dialog-close]="false">Close</button>
  <button class="btn-md-filled-primary ms-2" matRipple (click)="onSubmit()">Update</button>
</div>
